import { IBackgroundJob } from '@models/backgroundJobs/IBackgroundJob';
import { backgroundJobKind, primaryJobAction } from '@services/backgroundJobs/backgroundJobKinds';
import { jobStateLabel } from '@services/backgroundJobs/backgroundJobView';
import { ToastNotification } from './NotificationToast.types';

export const jobOutcomeToastId = (jobId: string): string => `job-${jobId}`;

/**
 * Превью итога фоновой задачи у колокольчика — та же карточка, что у уведомления: тег `job.*` даёт категорию
 * «Фоновые задачи». Тема — итог одной фразой от сервера, пояснение — сводка успеха или причина отказа.
 */
export const jobOutcomeToast = (job: IBackgroundJob, receivedAt: number): ToastNotification => {
    const failed = job.status === 'failed';
    const subject =
        job.message?.trim() ||
        `${job.title?.trim() || backgroundJobKind(job.kind).defaultTitle}: ${jobStateLabel(job).toLowerCase()}`;
    const text = (failed ? job.error : job.summary)?.trim();

    return {
        id: jobOutcomeToastId(job.jobId),
        subject,
        tag: `job.${job.kind}.${job.status}`,
        receivedAt,
        job: {
            jobId: job.jobId,
            kind: job.kind,
            failed,
            text: text && text !== subject ? text : null,
            action: primaryJobAction(job),
            docId: job.docId ?? null,
        },
    };
};
